export default function EntitlementUsage() {
    return <div>EntitlementUsage</div>
}
